import {
  CollectionModel,
  createThunk,
  model,
  view,
} from 'mst-collection';
import { getRoot } from 'mobx-state-tree';

import { Course, CourseModel } from './CourseModel';
import { Api, schemas } from '@api';
import { useRoot } from '@models/useRoot';
import { RootModelType } from '@models/RootModel';

export class CourseCollection extends CollectionModel(CourseModel) {
  fetchById = createThunk((id: number) => {
    return async function fetchById(this: CourseCollection, flow) {
      const res = await Api.Courses.getCourseById({ id });

      flow.merge(res.data, schemas.CourseSchema);
    };
  });

  @view
  getById(id: number): Course | undefined {
    return getRoot<RootModelType>(this).entities.courses.get(id);
  }
}

export const CourseCollectionModel = model(CourseCollection);

export function useCourseCollectionModel() {
  const root = useRoot();

  return root.entities.courses;
}
